import React from 'react';
import './privacy.css';

const Privacy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: December 19, 2023</p>

        <section className="privacy-section">
          <h2>Introduction</h2>
          <p>
            At InspiraPix, we take your privacy seriously. This Privacy Policy explains how we collect,
            use, disclose, and safeguard your information when you use our website and services.
            Please read this privacy policy carefully. If you do not agree with the terms of this
            privacy policy, please do not access the site.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Information We Collect</h2>
          <h3>Personal Information</h3>
          <p>We may collect personal information that you voluntarily provide to us when you:</p>
          <ul>
            <li>Register for an account</li>
            <li>Sign up for our newsletter</li>
            <li>Contact us for support</li>
            <li>Participate in contests or surveys</li>
          </ul>
          <p>This information may include:</p>
          <ul>
            <li>Name and email address</li>
            <li>Username and password</li>
            <li>Payment information</li>
            <li>Social media profile information</li>
          </ul>

          <h3>Usage Information</h3>
          <p>We automatically collect certain information when you visit our website, including:</p>
          <ul>
            <li>IP address and browser type</li>
            <li>Pages you view and links you click</li>
            <li>Time spent on pages</li>
            <li>Device information</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide and maintain our services</li>
            <li>Improve user experience</li>
            <li>Process transactions</li>
            <li>Send administrative information</li>
            <li>Respond to inquiries and support requests</li>
            <li>Send marketing communications (with your consent)</li>
            <li>Protect against unauthorized access</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>Information Sharing</h2>
          <p>We may share your information with:</p>
          <ul>
            <li>Service providers and business partners</li>
            <li>Analytics providers</li>
            <li>Law enforcement when required by law</li>
          </ul>
          <p>
            We do not sell your personal information to third parties.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your personal
            information. However, no method of transmission over the internet or electronic storage
            is 100% secure, and we cannot guarantee absolute security.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal information</li>
            <li>Correct inaccurate information</li>
            <li>Request deletion of your information</li>
            <li>Object to processing of your information</li>
            <li>Withdraw consent</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>Cookies</h2>
          <p>
            We use cookies and similar tracking technologies to track activity on our website and
            hold certain information. You can instruct your browser to refuse all cookies or to
            indicate when a cookie is being sent.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Children's Privacy</h2>
          <p>
            Our services are not intended for users under the age of 13. We do not knowingly
            collect information from children under 13. If you become aware that a child has
            provided us with personal information, please contact us.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Changes to This Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes
            by posting the new Privacy Policy on this page and updating the "Last Updated" date.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <p>
            Email: <a href="mailto:privacy@inspirapix.com">privacy@inspirapix.com</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Privacy; 